import type { HTTPService } from "@soft-db/http";

export type VibrationCriteriaSummary = {
	id: string;
	name: string;
};

export type VibrationCriteria = {
	id: string;
	name: string;
	extrapolate: boolean;
	points: VibrationCriteriaPoint[];
	site: string | null;
};

export type VibrationCriteriaPoint = {
	x: number;
	y: number;
};

export type CreateVibrationCriteria = {
	name: string;
	extrapolate: boolean;
	points: VibrationCriteriaPoint[];
};

export class VibrationCriteriaApi {
	constructor(private _http: HTTPService) {}

	async fetch(id: string) {
		return this._http.get<VibrationCriteria>(`vibration-criterias/${id}`);
	}

	async fetchGlobalCriterias() {
		return this._http.get<VibrationCriteriaSummary[]>("vibration-criterias");
	}

	async fetchSiteCriterias(site: string) {
		return this._http.get<VibrationCriteriaSummary[]>(`sites/${site}/vibration-criterias`);
	}

	async create(site: string, criteria: CreateVibrationCriteria) {
		return this._http.post<VibrationCriteria>(`sites/${site}/vibration-criterias`, criteria);
	}

	async update(id: string, criteria: CreateVibrationCriteria) {
		return this._http.put<VibrationCriteria>(`vibration-criterias/${id}`, criteria);
	}

	async delete(id: string) {
		return this._http.delete(`vibration-criterias/${id}`);
	}
}
